import { useState, useEffect, useCallback, useRef } from "react";
import { useOrientation } from "./useOrientation";

interface Size {
  width: number | undefined;
  height: number | undefined;
}

export function useWindowSize(): Size {
  const removed = useRef(false);
  const [windowSize, setWindowSize] = useState<Size>({
    width: undefined,
    height: undefined,
  });

  const { orientation } = useOrientation();

  const handleResize = useCallback(() => {
    if (!removed.current) {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight - 1,
      });
    }
  }, []);

  useEffect(() => {
    handleResize();
  }, [orientation, handleResize]);

  useEffect(() => {
    window.addEventListener("resize", handleResize, false);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
      removed.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return windowSize;
}
